module.exports = __webpack_public_path__ + "img/BCI.3d1948c.png";